import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../global/commonStyle';

interface Prop {
  isLoading?: boolean;
  isMonthPicker?: boolean;
  isBottomBorder?: boolean;
}

const BoxWrapper = styled.div`
  position: relative;
  height: 100%;
  ${HideScrollbar}
`;

const Header = styled.div<Prop>`
  position: sticky;
  z-index: var(--z-index-999);
  ${Typography.heading_lg}
  color: var(--text-primary);
  top: 0;
  padding: var(--space-10) var(--space-24);
  background-color: var(--background-secondary);
  ${FlexBetween}
  gap: var(--space-24);
  ${({ isBottomBorder }) =>
    isBottomBorder &&
    css`
      border-bottom: 0.5px solid var(--border-primary);
    `}
  p {
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
  .date-selector {
    p {
      min-width: 140px;
      text-align: center;
    }
  }
`;
const HeaderLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
`;

const HeaderTitle = styled.p`
  ${Typography.heading_md}
  font-weight: 600;
  color: var(--text-primary);
  margin-block: var(--space-3);
`;

const HeaderRight = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const ContentHeading = styled.div`
  display: flex;
  gap: var(--space-8);
  ${mobile_xl(css`
    display: grid;
    grid-template-columns: repeat(1, 2fr);
  `)}
`;
const LeftContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--space-8);
  position: relative;
  .dropdown-icon {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    max-width: -webkit-fill-available;
    display: grid;
    grid-template-columns: 0.9fr 1fr;
    .third-child {
      grid-column: 1 / span 2;
    }
  `)}
`;
const DropdownButton = styled.div<Prop>``;

const RightContent = styled.div`
  position: relative;
  ${FlexCenter}
  .custom-dropdown {
    border-color: var(--border-primary);
    border-radius: var(--border-radius-8) var(--border-radius-0) var(--border-radius-0) var(--border-radius-8);
    width: max-content;
    ${mobile_xl(css`
      width: unset;
    `)}
  }
  .calendar-dropdown {
    border-color: var(--border-primary);
    border-radius: var(--border-radius-0) var(--border-radius-8) var(--border-radius-8) var(--border-radius-0);
    width: max-content;
    box-shadow: var(--top-right-border), var(--bottom-border);
    &:hover {
      box-shadow: var(--top-right-border), var(--bottom-border);
    }
    ${mobile_xl(css`
      width: unset;
      p {
        width: 100%;
        text-align: left;
      }
    `)}
  }
  .dropdown-icon {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    max-width: calc(100vw - 40px);
    display: grid;
    grid-template-columns: 0.93fr 1.07fr;
  `)}
`;

const Text = styled.div`
  ${Typography.body_md}
  text-align: center;
  color: var(--text-primary);
  margin: var(--space-0);
  span {
    color: var(--brand-primary);
    padding-left: var(--space-12);
    border-left: 0.5px solid var(--border-primary);
  }
`;
const Total = styled.div`
  ${FlexCenter}
  gap: var(--space-4);
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-0) var(--space-24) var(--space-24);
  ${mobile_xl(css`
    width: calc(100vw - 40px);
    padding: var(--space-8) var(--space-20) var(--space-96);
    gap: var(--space-16);
  `)};
`;

const DateDropBox = styled.div<Prop>`
  position: absolute;
  right: 0;
  max-width: min-content;
  background: var(--background-primary);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-0);
  margin-top: var(--space-5);
  z-index: var(--z-index-99);
  box-shadow: var(--shadow-dropdown);

  .react-calendar__navigation {
    margin-bottom: var(--space-10);
  }
  .react-calendar__navigation button {
    background: none;
    ${Typography.body_lg}
    margin-top:var(--space-0);
    padding-inline: var(--space-3);
  }
  .react-calendar__tile--now:enabled:hover,
  .kKROaE .react-calendar__tile--now:enabled:focus {
    border-radius: var(--border-radius-full);
  }
  .rdrStartEdge .rdrEndEdge {
    color: var(--brand-primary) !important;
  }
  .menuStyle {
    box-shadow: none;
    padding: var(--space-0);
    display: flex;
    flex-direction: column;
    .menuitem {
      white-space: nowrap;
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
    }
  }
  .rdrMonth .rdrDayDisabled {
    background-color: var(--background-primary);
  }
  .rdrCalendarWrapper {
    background-color: var(--background-primary);
    border-radius: var(--border-radius-8);
  }
  .rdrDayNumber span {
    color: var(--text-primary);
  }
  .rdrDayPassive .rdrDayNumber span {
    color: var(--text-secondary);
  }
  .rdrWeekDay {
    color: var(--text-secondary);
  }
  .rdrDay {
    color: var(--text-secondary) !important ;
  }

  .rdrDateDisplayWrapper {
    background-color: var(--background-primary);
    border-radius: var(--border-radius-8);
  }
  .rdrDateDisplayItem input {
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    color: var(--text-primary);
    border-radius: var(--border-radius-4);
  }
  .rdrDateDisplayItem {
    background-color: var(--background-primary);
    box-shadow: none;
  }
  .rdrMonthAndYearPickers select:hover {
    background-color: var(--neutral-secondary);
  }
  .rdrMonthAndYearPickers select {
    color: var(--text-primary);
  }
  .rdrDateDisplay {
    color: transparent !important ;
  }
  .rdrNextPrevButton {
    background-color: var(--neutral-secondary);
  }
  .rdrStartEdge {
    color: var(--text-secondary) !important;
  }
  .rdrInRange {
    color: var(--text-secondary) !important;
  }
  .rdrEndEdge {
    color: var(--text-secondary) !important;
  }
  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: var(--background-primary);
  }

  .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after {
    background-color: var(--background-primary);
  }
  .rdrNextButton i {
    border-color: transparent transparent transparent var(--text-primary);
  }
  .rdrPprevButton i {
    border-color: transparent var(--text-primary) transparent transparent;
  }
  ${(props) =>
    props.isLoading &&
    css`
      opacity: 0.8;
      cursor: default;
      pointer-events: none;
    `}
`;

const TableSection = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  ${HideScrollbar}
`;

const ItemDiv = styled.div`
  max-width: 154px;
  min-width: 154px;
  width: 100%;
  ${mobile_xl(css`
    max-width: unset;
  `)}
`;

export {
  Header,
  ContentHeading,
  RightContent,
  LeftContent,
  Text,
  Total,
  Content,
  DateDropBox,
  TableSection,
  DropdownButton,
  HeaderLeft,
  ItemDiv,
  HeaderRight,
  HeaderTitle,
  BoxWrapper
};
